import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { type LineageColour, LineagePage, type LineageScope } from "@/features/lineage/LineagePage";
import { lineageQuery } from "@/lib/api/queries";
import { DEFAULT_ENV, projectSearch } from "@/lib/search";

/** `?model=` deep-links a selection — the command palette and every "Lineage" button use it. */
const search = projectSearch.extend({
  model: z.string().optional(),
  scope: z.enum(["all", "upstream", "downstream"]).optional(),
  colour: z.enum(["result", "materialization", "coverage"]).optional(),
});

export const Route = createFileRoute("/w/$workspace/p/$project/lineage")({
  validateSearch: search,
  loaderDeps: ({ search: s }) => ({ env: s.env ?? DEFAULT_ENV }),
  loader: ({ context, params, deps }) =>
    context.queryClient.ensureQueryData(lineageQuery(params.workspace, params.project, deps.env)),
  component: () => {
    const { workspace, project } = Route.useParams();
    const s = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <LineagePage
        workspace={workspace}
        project={project}
        env={s.env ?? DEFAULT_ENV}
        selected={s.model ?? null}
        scope={(s.scope ?? "all") as LineageScope}
        colour={(s.colour ?? "result") as LineageColour}
        onSearch={(patch) =>
          navigate({
            search: (prev) => ({
              env: prev.env,
              model: patch.model === undefined ? prev.model : (patch.model ?? undefined),
              scope:
                (patch.scope ?? prev.scope) === "all" ? undefined : (patch.scope ?? prev.scope),
              colour:
                (patch.colour ?? prev.colour) === "result"
                  ? undefined
                  : (patch.colour ?? prev.colour),
            }),
            replace: true,
          })
        }
      />
    );
  },
});
